module.exports = __webpack_public_path__ + "media/images/cplook/cc-visa-f5bfc20fb6b48c126026eea369cdd1bc.gif";